import React, { useMemo } from "react"
import { Flex, type FlexProps } from '@/index'
import { StepsItemContext } from './StepsItem/context'
import { StepsContext } from './context'


interface StepsProps extends FlexProps {
  activeStep?: number,
  orientation?: 'horizontal' | 'vertical',
}


const Component = React.forwardRef((props: StepsProps, ref: React.Ref<any>) => {
  const {
    activeStep = -1,
    orientation = 'horizontal',
    children,
    ...otherProps
  } = props

  const context = useMemo(() => {
    return {
      orientation
    }
  }, [orientation]);

  const steps = useMemo(() => {
    const nodes = React.Children.toArray(children)

    return nodes.map((item, index) => {
      const stepsItemIndex = ~~(index / 2)

      return (
        <StepsItemContext.Provider
          key={index}
          value={{
            active: stepsItemIndex === activeStep,
            completed: stepsItemIndex < activeStep,
          }}
        >
          {item}
        </StepsItemContext.Provider>
      );
    });
  }, [activeStep, children]);

  return (
    <Flex
      ref={ref}
      w='100%'
      alignItems='center'
      direction={orientation === 'horizontal' ? 'row' : 'column'}
      { ...otherProps }
    >
      <StepsContext.Provider value={context}>
        {steps}
      </StepsContext.Provider>
    </Flex>
  )
})


export {
  Component as Steps,
  type StepsProps
}
